<template>
  <b-breadcrumb-item
    :active="last"
    :text="label"
    @click="updateStoryPath"
  />
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  label: {
    type: String,
    required: true,
  },
  last: {
    type: Boolean,
    default: false,
  },
  path: {
    type: String,
    required: true,
  },
}

@Component
export default class BreadcrumbItem extends Vue.extend({ props }) {
  updateStoryPath () {
    this.$typedStore.activeVisualisation.updateStoryPath(this.path)
  }
}

</script>
